<template>
    <div>
        <Title title="我的优惠" path="/my"/>
        <template v-if="init===false">
        <div class="fxboex tabpanel">
            <van-tabs v-model="tab_active">
                <van-tab :title="'未使用('+total[0]+')'"/>
                <van-tab :title="'已使用('+total[1]+')'"/>
                <van-tab :title="'已失效('+total[2]+')'"/>
            </van-tabs>
        </div>
        <div class="tabpanel_lh"></div>
        </template>

        <div class="userwrap">

            <template v-if="init===false">
                <template v-if="list.length>0">
                    <div class="mycoupon">
                        <div v-for="(c, i) in list" :key="i" :class="type != 1?'item itemdis':'item'">
                            <div class="con">
                                <div class="amt">{{ c.amt }}<em>FXB</em></div>
                                <div class="name">{{ c.name }}</div>
                                <div class="time" v-if="type===1">有效期至 /&nbsp;&nbsp;&nbsp;{{ c.end_time }}</div>
                                <div class="time" v-else-if="type===2">已使用</div>
                                <div class="time" v-else-if="type===3">已失效</div>
                                <div class="tag lk" v-if='type===1'><router-link to="/ball">去使用</router-link></div>
                                <div class="tag consdel" v-else-if='type===2||type===3' @click="del(i)"></div>
                            </div>
                        </div>
                    </div>
                </template>
                <van-empty description="没有内容~" v-else/>
            </template>
            <div class="page-loading" v-else>
                <van-skeleton title :row="8" />
            </div>

        </div>

    </div>
</template>

<script>
    import '../../assets/css/user.css'
    import Title from '../public/title'
    export default {
        name: "coupon",
        components: {
            Title
        },
        data (){
            return {
                tab_active: 0,
                list: [],
                total: [0,0,0],
                type: 1,
                init: true,
            }
        },
        watch: {
            '$route'(v) {
                if(v.path.indexOf('/coupon')>-1) {
                    this.init = true
                    this.tab_active = 0
                    this.type = 1
                    this.total = [0, 0, 0]
                    this.getdata()
                }
            },
            tab_active(i){
                // this.$toast.loading()
                // this.init = true
                this.type = i+1
                this.getdata()
            },
        },
        activated() {
            let that = this
            that.getdata()
        },
        methods: {
            getdata(){
                let that = this
                this.$get(that.$api.member_coupon, {type: that.type}).then(function (res) {
                    if (res.code === 1){
                        that.list = res.data.list
                        that.total = res.data.total
                    }
                    that.init = false
                    // that.$toast.clear()
                })
            },
            del(i){
                let that = this
                that.$dialog.confirm({message: '确定删除？'}).then(()=>{
                    let id = that.list[i].id
                    that.$post(that.$api.member_coupon_delete, {id: id}).then(res=>{
                        if(res.code === 1){
                            that.$toast.success(res.msg)
                            that.list.splice(i, 1)
                            // that.total[that.tab_active] -= that.total[that.tab_active]
                        }
                        else
                            that.$toast.fail(res.msg)
                    })
                }).catch(()=>{})
            }
        },
    }
</script>

<style scoped>

</style>
